import React from 'react'
import { motion } from 'framer-motion';

import './Coins.css'

const Coins = ({name, image, symbol, price, volume, priceChange, marketcap}) => {
  return (
    <>
    <motion.div
     whileInView={{y: [-10, 0], opacity: [0, 1]}}
     className='coin-container'>
        <div className="coin-row">
            <div className="coin">
                <motion.img 
                whileHover={{scale: 1.1}}
                src={image} alt="crypto" />
                <h1>{name}</h1>
                <p className='coin-symbol'>{symbol}</p>
            </div>
            <div className="coin-data">
                <p className="coin-price">₹{price}</p>
                <p className="coin-volume">₹{volume.toLocaleString()}</p>
                {priceChange < 0 ? (
                    <p className="coin-percent red">{priceChange.toFixed(2)}%</p>) 
                    : 
                    (
                    <p className="coin-percent green">{priceChange.toFixed(2)}%</p>)
                }
                <p className="coin-marketcap">
                    Mkt Cap: ₹{marketcap.toLocaleString()}
                </p>
            </div>
        </div>
    </motion.div>
    </>
  )
}

export default Coins